import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77116770"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "circular-border" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "sort" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Ordenar por", -1))
const _hoisted_5 = { class: "sort-name" }
const _hoisted_6 = { class: "filter" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Filtrar por", -1))
const _hoisted_8 = { class: "sort-name" }
const _hoisted_9 = { class: "sort-name" }
const _hoisted_10 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_with_balance = _resolveComponent("header-with-balance")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_header_with_balance, {
            class: "balance-header",
            title: "Filtros",
            "has-go-back": true
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createVNode(_component_ion_grid, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_row, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sortBy, (sort) => {
                          return (_openBlock(), _createBlock(_component_ion_col, {
                            key: sort.value,
                            onClick: ($event: any) => ($options.sortByName(sort))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", {
                                class: _normalizeClass(["button-sort", { active: _ctx.orderName == sort.value }])
                              }, [
                                _createVNode(_component_ion_icon, {
                                  icon: sort.icon
                                }, null, 8, ["icon"])
                              ], 2),
                              _createElementVNode("span", _hoisted_5, _toDisplayString(sort.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_ion_segment, {
                  modelValue: $setup.valueFilterRef,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.valueFilterRef) = $event)),
                  color: "primary",
                  mode: "md"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_segment_button, { value: "default" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Padrão")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_segment_button, { value: "categories" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Categorias")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_segment_button, { value: "payment" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Pagamentos")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                ($setup.valueFilterRef == 'default')
                  ? (_openBlock(), _createBlock(_component_ion_grid, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_row, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filters, (filter) => {
                              return (_openBlock(), _createBlock(_component_ion_col, {
                                key: filter.id,
                                size: "3",
                                onClick: ($event: any) => ($options.filtersByPush(filter))
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["button-sort", { active: $options.isFilterActive(filter) }])
                                  }, [
                                    (filter.imageSrc && $options.isFilterActive(filter))
                                      ? (_openBlock(), _createBlock(_component_ion_icon, {
                                          key: 0,
                                          class: "filterLogo",
                                          src: filter.imageSelectedSrc
                                        }, null, 8, ["src"]))
                                      : (filter.imageSrc)
                                        ? (_openBlock(), _createBlock(_component_ion_icon, {
                                            key: 1,
                                            class: "filterLogo",
                                            src: filter.imageSrc
                                          }, null, 8, ["src"]))
                                        : (_openBlock(), _createBlock(_component_ion_icon, {
                                            key: 2,
                                            slot: "start",
                                            icon: filter.icon
                                          }, null, 8, ["icon"]))
                                  ], 2),
                                  _createElementVNode("span", _hoisted_8, _toDisplayString(filter.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                ($setup.valueFilterRef == 'payment')
                  ? (_openBlock(), _createBlock(_component_ion_grid, { key: 1 }, {
                      default: _withCtx(() => [
                        ($setup.loadingRef)
                          ? (_openBlock(), _createBlock(_component_ion_spinner, { key: 0 }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_ion_row, { class: "payments-row" }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.paymentMethodsRef, (payment) => {
                              return (_openBlock(), _createBlock(_component_ion_col, {
                                key: payment.id,
                                size: "3",
                                onClick: ($event: any) => ($options.filtersByPushPayments(payment))
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["button-sort", { active: $options.isFilterPaymentsActive(payment) }])
                                  }, [
                                    _createVNode(_component_ion_icon, {
                                      slot: "start",
                                      class: "payment-image",
                                      src: `https://cdn.thelivery.com.br/${payment.logo}`
                                    }, null, 8, ["src"])
                                  ], 2),
                                  _createElementVNode("span", _hoisted_9, _toDisplayString(payment.name.replace(" (MAQUINETA)", "")), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                ($setup.valueFilterRef == 'categories')
                  ? (_openBlock(), _createBlock(_component_ion_grid, { key: 2 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_row, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.categoriesRef, (category) => {
                              return (_openBlock(), _createBlock(_component_ion_col, {
                                key: category.id,
                                size: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["button-categories", { active: $options.isCategoryActive(category) }]),
                                    onClick: ($event: any) => ($options.categoriesByPush(category))
                                  }, _toDisplayString(category.name), 11, _hoisted_10)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_the_button, {
                name: "Aplicar",
                onClick: $options.apply
              }, null, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}